import type { Chain } from '@safe-global/store/gateway/AUTO_GENERATED/chains'
import { FEATURES, hasFeature } from '@safe-global/utils/utils/chains'
import { SEISMIC_CHAIN_IDS } from './constants'

/**
 * True when the chain is a Seismic-style shielded EVM that requires signed reads / shielded writes.
 * Gated on the Seismic testnet id, or on a `SHIELDED_EVM` feature flag in the CGW chain config so
 * additional shielded chains can be onboarded without a code change.
 */
export const isShieldedChainId = (chainId: string | undefined): boolean =>
  chainId != null && SEISMIC_CHAIN_IDS.has(chainId)

export const isShieldedChain = (chain: Pick<Chain, 'chainId' | 'features'> | undefined): boolean => {
  if (!chain) return false
  if (isShieldedChainId(chain.chainId)) return true
  return chain.features != null && hasFeature(chain, FEATURES.SHIELDED_EVM)
}
